var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons"},[(!_vm.prevHide)?_c('a',{staticClass:"button prev",attrs:{"href":"javascript:","data-content":"Anterior","data-toggle":"popover","data-id":"prev"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fa fa-angle-left"})]):_vm._e(),_vm._v(" "),_c('a',{class:[
			'button next',
			{ 'disabled': _vm.disabled }
		],attrs:{"href":"javascript:","data-content":"Próximo","data-toggle":"popover","data-id":"next","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fa fa-angle-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }